import ExternalLink from '@/components/atoms/ExternalLink';
import React from 'react';

/**
 * 「解約画面(レンタルWifi)」の重要事項制御コンポーネント。
 */
const QuitTextMobileRentalWifi = () => {
  return (
    <div className='m-box-02'>
      <div className='m-text'>
        {/* レンタルWiFiは機器回収条件が中心になるため、返却物と集荷条件を厚めに説明する。 */}
        <ul className='m-list'>
          <li className='m-list__item'>
            解約月も1ヶ月の月額料金がかかります（日割は行いません）。
          </li>
          <li className='m-list__item'>解約に伴う解約金（違約金）は発生いたしません。</li>
          <li className='m-list__item'>
            解約完了後、レンタル機器（付属品含む）を回収させていただきます。
          </li>
          <li className='m-list__item'>
            レンタル機器（付属品含む）の返却について、以下ご確認ください。
          </li>
          <div style={{ marginLeft: '1em' }}>
            －解約お手続き後、回収のためご指定の日付・お時間帯に集荷訪問させていただきます。ページ下部より希望日をご指定ください。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －集荷訪問時に回収できなかった場合、不在票より再度集荷の受付を行ってください。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －ご返却いただけない場合は機器未返却による損害金を請求させていただきます。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －集荷に伺う住所について、特にご指定のない場合は「機器送付先住所」へお伺いいたします。送付先住所とは別の住所への集荷希望の場合、下記入力欄にてご指定くださいますようお願いいたします。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －機器は梱包いただいた上、お手元で保管くださいますようお願いいたします。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －必要な返却物は以下となります。すべてご返却ください。
          </div>
          <div style={{ marginLeft: '2em' }}>
            Wi-Fiルータ（FS030W）、ルータ付属の充電ケーブル、ルータ付属のACアダプター、ルータ内臓のSIM（取り外さないこと）、SIM用カード（白いカード）
          </div>
          <div style={{ marginLeft: '1em' }}>
            －返却物に不足があった場合、端末損害金が発生する場合がございます。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －返却物が再利用不可能な状態（破損/汚損による）だった場合、端末損害金が発生する場合がございます。
          </div>
          <br />
          <li className='m-list__item'>誤返却物の取り扱いについて</li>
          <div style={{ marginLeft: '1em' }}>
            －レンタル機器（付属品含む）をご返却の際には、お客さまの私物（以下、私物品）を誤って送付しないようご注意ください。
          </div>
          <div style={{ marginLeft: '1em' }}>
            －私物品については、到着後に廃棄いたします。またお客さまへのご返却も行えません。
          </div>
        </ul>
      </div>
      {/* 規約確認後に集荷先と希望日時入力へ進む流れを明示する。 */}
      <div>解約お申し込みは下記規約類を必ずお読みになったうえで、お手続きください。</div>
      <br />
      <div>NUROモバイル レンタルWi-Fiサービスに関する規約</div>
      <br />
      <div className='m-text'>
        <ul className='m-list'>
          <li className='m-list__item'>
            <ExternalLink href='https://mobile.nuro.jp/r/legal/rentalwifi/rule/'>
              ご利用規約
            </ExternalLink>
          </li>
        </ul>
      </div>
      <br />
      <div>
        上記注意事項をご確認いただけましたら、集荷先のご住所、また回収ご希望の日付・時間帯をご指定ください。
      </div>
      <div>その後、チェックボックスにチェックを入れていただいた上で「解約」をご選択ください。</div>
      <br />
      <div>※当サービスを解約されても、NURO光各種サービスは自動的に解約されません。</div>
      <div>※このページでは解約のお手続きは完了いたしません。</div>
    </div>
  );
};

export default QuitTextMobileRentalWifi;
